'use client';

import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

const EXTERNAL_AUTH_ID = 'external_auth_id';

export function useExternalAuthId(): string | null {
    const searchParams = useSearchParams();
    return searchParams.get(EXTERNAL_AUTH_ID);
}
